import request from "@/utils/request";

export function getGoodsPage(data,pageNum,pageSize) {
    return request({
        url: `/goods/findPage`,
        method: 'post',
        params:{pageNum,pageSize},
        data
    })
}
